var render, staticRenderFns
import script from "./QCarrierDataTable.vue?vue&type=script&lang=js&"
export * from "./QCarrierDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QCarrierDataTable.vue?vue&type=style&index=0&id=885597f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885597f0",
  null
  
)

export default component.exports